<template>
  <canvas :id="canvasId" :width="50000" :height="colheight + 200"></canvas>
</template>

<script>
import { floatMul, floatDiv } from '@/utils/utils';
export default {
  name: 'fenceCanvas',
  props: {
    columnColor: {
      // 中间固定柱颜色
      type: String,
      default: '#666666'
    },

    colorData: {
      // 每列板子颜色数组
      type: Array
    },

    canvasId: {
      // canvasId
      type: String,
      default: 'canvasId1'
    },

    reallength: {
      // 围栏总长
      type: Number,
      default: 2600
    },

    colheight: {
      // 围栏高度
      type: Number,
      default: 300
    },

    boardNum: {
      // 每列板子数量
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      notOnly: true, // 是否只有一列
      backgroundColor: 'rgb(248, 248, 248)', // 画布背景色
      realboardwidth: 2000, // 实际板的宽度2000mm
      lastboardminwidth: 1000, // 最后一段最小尺寸 默认1000mm

      colwidth: 20, // 柱子宽度

      colPad: 10, // 柱子行向间距
      zjsWidth: 6, // 直继手/小口帽宽度

      boardwidth: 400, //  板子宽度
      lastboardwidth: null, // 最后一列板子的宽度 动态计算

      boardheight: 20, // 板子高度

      colNum: 5, // 列数

      boardData: [], // 板数据
      xkmData: [], // 小口帽数据

      colData: [], // 柱子数据

      nailData: [], // 钉子数据

      middleNailDta: [], // 中间钉子数据

      nailColor: '#B7A6A5', // 钉子颜色

      colColor: '#897C7A', // 柱子颜色

      nailradius: 3, // 钉子半径

      middleColunmData: [], // 中间柱子数据
      //============================new data
      startAndEndW: 100, // 收尾保留长度
      lastW: 0, // 余数
      fixColNum: null,
      lastStructure: null,
      lastStructureType: null // 结尾围栏切割类型
    };
  },
  mounted() {
    this.newInit();
  },
  methods: {
    // 根据实际尺寸等比计算绘图数据
    changeData(data) {
      return floatMul(floatDiv(this.boardwidth, this.realboardwidth), data); // (板子绘画宽度/实际板子宽度) * 实际数据
    },

    changeRealData(data) {
      return floatMul(floatDiv(this.realboardwidth, this.boardwidth), data);
    },

    newInit() {
      let fenceCanvas = document.getElementById(this.canvasId); // 获取DOM节点
      fenceCanvas.style.backgroundColor = this.backgroundColor; // 给DOM设置背景色
      let ctx = fenceCanvas.getContext('2d'); // 渲染画布
      // 判断固定列数与最后列的切割数据
      this.newformula(this.reallength);
      // 构造数据
      this.structureData();
      // 更新画布尺寸 （根据围栏长度更新画布的宽度，要在画图之前更新，否则没有画面）
      this.updataCanvaWidth(fenceCanvas);
      // 标尺（每列板子宽度）
      this.drawBoardSize(ctx);
      // 增加板子数量
      this.addBoardNum();
      // 增加直继手/小口帽数量
      this.addZjsNum();
      // 构造固定柱上钉子数据
      this.createMiddeleArcData();
      // 构造插地柱上钉子数据
      this.createArcData();
      // 标尺（地面 + 围栏总高 + 板子总高）
      this.drawSize(ctx);
      // 根据数据画图形（固定柱子 => 板子 => 插地柱子 => 钉子）
      this.drawNewFence(ctx);
    },

    // 最新公式计算
    newformula(reallength) {
      const colNum = Math.floor(reallength / 2000); // 列数向下取整
      const lastNum = reallength % 2000; // 余数

      if (colNum === 0) {
        // 只有一列 为两端立柱
        this.fixColNum = 0;
        this.lastStructure = `100 || ${reallength - 200} || 100`;
        this.lastStructureType = 10;
      } else if (colNum === 1) {
        // 有两列 检查余数
        this.fixColNum = 0;
        if (lastNum >= 500) {
          // 大于等于500 按lastNum一板
          this.lastStructure = `100 || 1800 | 100 | ${reallength - 2000 - 100} || 100`;
          this.lastStructureType = 9;
        } else if (lastNum > 0 && lastNum < 500) {
          // 大于0 小于500 和前一列平分两板
          this.lastStructure = `100 || ${(reallength - 200) / 2 - 100} | 100 | ${(reallength - 200) / 2} || 100`;
          this.lastStructureType = 8;
        } else {
          // 刚好为0 结尾不用处理了
          this.fixColNum = colNum;
          this.lastStructure = ``;
          this.lastStructureType = 7;
        }
      } else {
        // 三列以上
        // 判断余数
        if (lastNum === 0) {
          // 刚好为0 结尾不用处理了
          this.fixColNum = colNum;
          this.lastStructure = ``;
          this.lastStructureType = 7;
        } else if (lastNum >= 500) {
          // 大于等于500 按lastNum一板
          this.fixColNum = colNum;
          this.lastStructure = `${lastNum - 100} || 100`;
          this.lastStructureType = 6;
        } else {
          // 小于500 和前一列平分两板
          this.fixColNum = colNum - 1;
          this.lastStructure = `${(2000 + lastNum - 200) / 2} | 100 | ${(2000 + lastNum - 200) / 2} || 100`;
          this.lastStructureType = 5;
        }
      }
      console.log('🚀 ~ file: fenceComponentsNew.vue:178 ~ newformula ~ this.lastStructure:', this.lastStructure);
      console.log('🚀 ~ file: fenceComponentsNew.vue:155 ~ newformula ~ this.fixColNum:', this.fixColNum);
    },

    // 更新canvas画布尺寸
    updataCanvaWidth(dom) {
      // let width = dom.getAttribute("width"); // 获取当前画布宽度
      let height = parseInt(dom.getAttribute('height')); // 获取当前画布高度
      // let data = ctx.getImageData(0, 0, width, height); // 获取当前画布图像

      let width = this.boardData[this.boardData.length - 1].x + this.boardData[this.boardData.length - 1].width + 100;
      // 设置新的宽度 最后一个板子坐标 + 最后一个板子宽度 + 200

      dom.setAttribute('width', width); // 设置画布新的宽度
      dom.setAttribute('height', height); // 设置画布高度不变

      // ctx.putImageData(data, 0, 0); // 重新绘图
    },

    // 构造数据
    structureData() {
      // 板子 初始数据
      const startBoardData = {
        sx: 370,
        sy: 150,
        color: this.colorData[0].color // 第一行颜色
      };
      // 柱子 初始数据
      const startColData = {
        sx: startBoardData.sx + this.changeData(100), // 柱子起始坐标
        sy: 150,
        color: this.columnColor // 柱子颜色
      };
      // 直継手/小口帽 初始数据
      const startZjsData = {
        sx: startBoardData.sx - this.colPad, // - this.changeData(this.zjsWidth), // 小口帽起始坐标
        sy: 150,
        width: this.zjsWidth, // 直継手/小口帽固定宽
        color: this.colorData[0].color // 第一行颜色
      };

      if (this.fixColNum === 0) {
        // 根绝 this.lastStructure 直接构造数据
        if (this.lastStructureType === 10) {
          // this.lastStructure = `100 || ${reallength - 200} | 100`;

          // 左侧板子
          const boardData = {
            x: startBoardData.sx,
            y: startBoardData.sy,
            width: this.changeData(100),
            height: this.boardheight,
            color: startBoardData.color,
            i: 0
          };
          // 中间板子 排除左右存在的100板子，20柱子
          const boardData2 = {
            x: boardData.x + boardData.width + this.colwidth,
            y: boardData.y,
            width: this.changeData(this.reallength) - this.changeData(100) * 2,
            height: boardData.height,
            color: boardData.color,
            i: 0
          };
          // 右侧板子
          const boardData3 = {
            x: boardData2.x + boardData2.width + this.colwidth,
            y: boardData2.y,
            width: this.changeData(100),
            height: boardData2.height,
            color: boardData2.color,
            i: 0
          };
          // 添加板子数据
          this.boardData.push(boardData);
          this.boardData.push(boardData2);
          this.boardData.push(boardData3);

          // 左侧柱子
          const colData = {
            x: startBoardData.sx + this.changeData(100),
            y: startBoardData.sy,
            width: this.colwidth,
            height: this.colheight + 20,
            color: this.columnColor
          };
          // 右侧柱子
          const colData2 = {
            x: colData.x + colData.width + boardData2.width,
            y: colData.y,
            width: colData.width,
            height: colData.height,
            color: colData.color
          };
          this.colData.push(colData);
          this.colData.push(colData2);

          // 左侧小口帽
          const xkmData = {
            x: startZjsData.sx,
            y: startZjsData.sy,
            width: startZjsData.width,
            height: boardData.height,
            color: boardData.color
          };
          // 右侧小口帽
          const xkmData2 = {
            x: xkmData.x + this.colPad + this.changeData(this.reallength) + (this.colPad - this.zjsWidth),
            y: xkmData.y,
            width: xkmData.width,
            height: xkmData.height,
            color: xkmData.color
          };
          this.xkmData.push(xkmData);
          this.xkmData.push(xkmData2);
        } else if (this.lastStructureType === 9) {
          // this.lastStructure = `100 || 1800 | 100 | ${reallength - 2000 - 100} || 100`;

          // 左侧板子
          const boardData = {
            x: startBoardData.sx,
            y: startBoardData.sy,
            width: this.changeData(100),
            height: this.boardheight,
            color: startBoardData.color,
            i: 0
          };
          // 中间1板子
          const boardData2 = {
            x: boardData.x + boardData.width + this.colwidth,
            y: boardData.y,
            width: this.changeData(1800),
            height: boardData.height,
            color: boardData.color,
            i: 0
          };
          // 中间2板子 100mm
          const boardData3 = {
            x: boardData2.x + boardData2.width + this.colwidth,
            y: boardData2.y,
            width: this.changeData(100),
            height: boardData2.height,
            color: boardData2.color,
            i: 0
          };
          // 中间3板子 剩余板子
          const boardData4 = {
            x: boardData3.x + boardData3.width, // + this.colPad,
            y: boardData3.y,
            width: this.changeData(this.reallength - 2000 - 100),
            height: boardData3.height,
            color: boardData3.color,
            i: 1
          };
          // 右侧板子
          const boardData5 = {
            x: boardData4.x + boardData4.width + this.colwidth,
            y: boardData4.y,
            width: this.changeData(100),
            height: boardData4.height,
            color: boardData4.color,
            i: 1
          };

          // 添加板子数据
          this.boardData.push(boardData);
          this.boardData.push(boardData2);
          this.boardData.push(boardData3);
          this.boardData.push(boardData4);
          this.boardData.push(boardData5);

          // 左侧柱子
          const colData = {
            x: startBoardData.sx + this.changeData(100),
            y: startBoardData.sy,
            width: this.colwidth,
            height: this.colheight + 20,
            color: this.columnColor
          };
          // 中间柱子
          const colData2 = {
            x: colData.x + colData.width + boardData2.width,
            y: colData.y,
            width: colData.width,
            height: colData.height,
            color: colData.color
          };
          // 右侧柱子
          const colData3 = {
            x: colData2.x + colData2.width + this.changeData(this.reallength - 2000), // + this.colPad,
            y: colData2.y,
            width: colData2.width,
            height: colData2.height,
            color: colData2.color
          };
          this.colData.push(colData);
          this.colData.push(colData2);
          this.colData.push(colData3);

          // 左侧小口帽
          const xkmData = {
            x: startZjsData.sx,
            y: startZjsData.sy,
            width: startZjsData.width,
            height: boardData.height,
            color: boardData.color
          };
          // 中间直继手 左侧起始点 + 左侧板子完整长度2000 + 左侧两个柱 + 左侧起始点偏移量 + 右侧间距
          const xkmData2 = {
            x: xkmData.x + this.changeData(2000) + this.colwidth * 2 + this.colPad + (this.colPad - this.zjsWidth - 2),
            y: xkmData.y,
            width: xkmData.width,
            height: xkmData.height,
            color: xkmData.color
          };
          // 右侧小口帽 中间直继手位置 + 右侧柱宽 + 剩余宽度 + 柱间距（这里其实包含直继手本身宽度+左右间距）
          const xkmData3 = {
            x: xkmData2.x + 2 + this.colwidth + this.changeData(this.reallength - 2000) + this.colPad,
            y: xkmData2.y,
            width: xkmData2.width,
            height: xkmData2.height,
            color: xkmData2.color
          };
          this.xkmData.push(xkmData);
          this.xkmData.push(xkmData2);
          this.xkmData.push(xkmData3);
        } else if (this.lastStructureType === 8) {
          // this.lastStructure = `100 || ${(reallength - 200) / 2 - 100} | 100 | ${(reallength - 200) / 2} || 100`;

          // 左侧板子
          const boardData = {
            x: startBoardData.sx,
            y: startBoardData.sy,
            width: this.changeData(100),
            height: this.boardheight,
            color: startBoardData.color,
            i: 0
          };
          // 中间1板子
          const boardData2 = {
            x: boardData.x + boardData.width + this.colwidth,
            y: boardData.y,
            width: this.changeData((this.reallength - 200) / 2 - 100),
            height: boardData.height,
            color: boardData.color,
            i: 0
          };
          // 中间2板子 100mm
          const boardData3 = {
            x: boardData2.x + boardData2.width + this.colwidth,
            y: boardData2.y,
            width: this.changeData(100),
            height: boardData2.height,
            color: boardData2.color,
            i: 0
          };
          // 中间3板子 剩余板子
          const boardData4 = {
            x: boardData3.x + boardData3.width, // + this.colPad,
            y: boardData3.y,
            width: this.changeData((this.reallength - 200) / 2),
            height: boardData3.height,
            color: boardData3.color,
            i: 1
          };
          // 右侧板子
          const boardData5 = {
            x: boardData4.x + boardData4.width + this.colwidth,
            y: boardData4.y,
            width: this.changeData(100),
            height: boardData4.height,
            color: boardData4.color,
            i: 1
          };

          // 添加板子数据
          this.boardData.push(boardData);
          this.boardData.push(boardData2);
          this.boardData.push(boardData3);
          this.boardData.push(boardData4);
          this.boardData.push(boardData5);

          // 左侧柱子
          const colData = {
            x: startBoardData.sx + this.changeData(100),
            y: startBoardData.sy,
            width: this.colwidth,
            height: this.colheight + 20,
            color: this.columnColor
          };
          // 中间柱子
          const colData2 = {
            x: colData.x + colData.width + boardData2.width,
            y: colData.y,
            width: colData.width,
            height: colData.height,
            color: colData.color
          };
          // 右侧柱子
          const colData3 = {
            // x: colData2.x + colData2.width + this.changeData((this.reallength - 200) / 2 + 100),
            x: colData2.x + colData2.width + boardData3.width + boardData4.width,
            y: colData2.y,
            width: colData2.width,
            height: colData2.height,
            color: colData2.color
          };
          this.colData.push(colData);
          this.colData.push(colData2);
          this.colData.push(colData3);

          // 左侧小口帽
          const xkmData = {
            x: startZjsData.sx,
            y: startZjsData.sy,
            width: startZjsData.width,
            height: boardData.height,
            color: boardData.color
          };
          // 中间直继手 左侧起始点 + 左侧板子长度 + 左侧两个柱 + 左侧起始点偏移量 + 右侧间距
          const xkmData2 = {
            x: xkmData.x + this.changeData((this.reallength - 200) / 2 + 100) + this.colwidth * 2 + this.colPad + (this.colPad - this.zjsWidth - 2),
            y: xkmData.y,
            width: xkmData.width,
            height: xkmData.height,
            color: xkmData.color
          };
          // 右侧小口帽 中间直继手位置 + 右侧柱宽 + 剩余宽度 + 柱间距（这里其实包含直继手本身宽度+左右间距）
          const xkmData3 = {
            x: xkmData2.x + 2 + this.colwidth + this.changeData((this.reallength - 200) / 2 + 100) + this.colPad,
            y: xkmData2.y,
            width: xkmData2.width,
            height: xkmData2.height,
            color: xkmData2.color
          };
          this.xkmData.push(xkmData);
          this.xkmData.push(xkmData2);
          this.xkmData.push(xkmData3);
        }
      } else {
        // 根据列数构造数据
        for (let i = 0; i < this.fixColNum; i++) {
          if (i === 0) {
            // 第一列 前面加一个柱子 板子分两部分
            // 左侧板子
            const boardData = {
              x: startBoardData.sx,
              y: startBoardData.sy,
              width: this.changeData(100),
              height: this.boardheight,
              color: startBoardData.color,
              i
            };
            // 中间板子 排除左右存在的100板子，20柱子
            const boardData2 = {
              x: boardData.x + boardData.width + this.colwidth,
              y: boardData.y,
              width: this.changeData(1800),
              height: boardData.height,
              color: boardData.color,
              i
            };
            // 右边板子 排除左右存在的100板子，20柱子
            const boardData3 = {
              x: boardData2.x + boardData2.width + this.colwidth,
              y: boardData2.y,
              width: this.changeData(100),
              height: boardData2.height,
              color: boardData2.color,
              i
            };
            // 添加板子数据
            this.boardData.push(boardData);
            this.boardData.push(boardData2);
            this.boardData.push(boardData3);

            // 左侧柱子
            const colData = {
              x: startBoardData.sx + this.changeData(100),
              y: startBoardData.sy,
              width: this.colwidth,
              height: this.colheight + 20,
              color: this.columnColor
            };
            // 右侧柱子
            const colData2 = {
              x: colData.x + colData.width + boardData2.width,
              y: colData.y,
              width: colData.width,
              height: colData.height,
              color: colData.color
            };
            // 添加柱子数据
            this.colData.push(colData);
            this.colData.push(colData2);

            // 左侧小口帽
            const xkmData = {
              x: startZjsData.sx,
              y: startZjsData.sy,
              width: startZjsData.width,
              height: boardData.height,
              color: boardData.color
            };
            // 右侧直继手
            const xkmData2 = {
              x: xkmData.x + this.colPad + this.colwidth * 2 + this.changeData(2000) + (this.colPad - this.zjsWidth - 2),
              y: xkmData.y,
              width: xkmData.width,
              height: xkmData.height,
              color: xkmData.color
            };
            this.xkmData.push(xkmData);
            this.xkmData.push(xkmData2);
          } else {
            // 第二列开始之后板子数据
            const prevBoardData = this.boardData[this.boardData.length - 1];
            // 第二列开始之后柱子数据
            const prevColData = this.colData[this.colData.length - 1];
            // 第二列开始之后直继手/小口帽数据
            const prevXkmData = this.xkmData[this.xkmData.length - 1];

            // 左侧1900板子
            const boardData = {
              x: prevBoardData.x + prevBoardData.width, // + this.colPad,
              y: prevBoardData.y,
              width: this.changeData(1900),
              height: prevBoardData.height,
              color: prevBoardData.color,
              i
            };
            // 右边100板子
            const boardData2 = {
              x: boardData.x + boardData.width + this.colwidth,
              y: boardData.y,
              width: this.changeData(100),
              height: boardData.height,
              color: boardData.color,
              i
            };
            // 添加板子数据
            this.boardData.push(boardData);
            this.boardData.push(boardData2);

            // 右侧柱子
            const colData = {
              x: prevColData.x + prevColData.width + this.changeData(2000), // + this.colPad,
              y: prevColData.y,
              width: prevColData.width,
              height: prevColData.height,
              color: prevColData.olor
            };
            this.colData.push(colData);

            // 右侧直继手
            const xkmData = {
              x: prevXkmData.x + prevXkmData.width + this.colwidth + this.changeData(2000) + (this.colPad - this.zjsWidth),
              y: prevXkmData.y,
              width: prevXkmData.width,
              height: prevXkmData.height,
              color: prevXkmData.color
            };
            this.xkmData.push(xkmData);
          }
        }

        // 根据结尾类型 分配不同的构造数据
        const lastNum = this.reallength % 2000; // 余数
        // 最后一列板子数据
        const prevBoardData = this.boardData[this.boardData.length - 1];
        // 最后一列柱子数据
        const prevColData = this.colData[this.colData.length - 1];
        // 最后一列直继手/小口帽数据
        const prevXkmData = this.xkmData[this.xkmData.length - 1];

        if (this.lastStructureType === 7) {
          // 结尾余数刚好为0 不用处理了
          // this.lastStructure = ``;
          // 最后一列的直继手 修改为小口帽
          prevXkmData.x = prevXkmData.x + 2;
        } else if (this.lastStructureType === 6) {
          // 结尾余数大于等于500 按结尾余数一板
          // this.lastStructure = `${lastNum - 100} || 100`;

          // 左侧lastNum - 100板子
          const boardData = {
            x: prevBoardData.x + prevBoardData.width, // + this.colPad,
            y: prevBoardData.y,
            width: this.changeData(lastNum - 100),
            height: prevBoardData.height,
            color: prevBoardData.color,
            i: prevBoardData.i + 1
          };
          // 右边100板子
          const boardData2 = {
            x: boardData.x + boardData.width + this.colwidth,
            y: boardData.y,
            width: this.changeData(100),
            height: boardData.height,
            color: boardData.color,
            i: prevBoardData.i + 1
          };
          // 添加板子数据
          this.boardData.push(boardData);
          this.boardData.push(boardData2);

          // 右侧柱子
          const colData = {
            x: prevColData.x + prevColData.width + this.changeData(lastNum), // + this.colPad,
            y: prevColData.y,
            width: prevColData.width,
            height: prevColData.height,
            color: prevColData.olor
          };
          this.colData.push(colData);

          // 右侧直继手
          const xkmData = {
            x: prevXkmData.x + prevXkmData.width + this.colwidth + this.changeData(lastNum) + (this.colPad - this.zjsWidth + 2),
            y: prevXkmData.y,
            width: prevXkmData.width,
            height: prevXkmData.height,
            color: prevXkmData.color
          };
          this.xkmData.push(xkmData);
        } else if (this.lastStructureType === 5) {
          // 结尾余数小于500 和前一列平分两板
          // this.lastStructure = `${(2000 + lastNum - 200) / 2} | 100 | ${(2000 + lastNum - 200) / 2} || 100`;

          // 左侧1 lastNum板子
          const boardData = {
            x: prevBoardData.x + prevBoardData.width, // + this.colPad,
            y: prevBoardData.y,
            width: this.changeData((2000 + lastNum - 200) / 2),
            height: prevBoardData.height,
            color: prevBoardData.color,
            i: prevBoardData.i + 1
          };
          // 左侧2 100板子
          const boardData2 = {
            x: boardData.x + boardData.width + this.colwidth,
            y: boardData.y,
            width: this.changeData(100),
            height: boardData.height,
            color: boardData.color,
            i: boardData.i
          };
          // 右侧1 lastNum板子
          const boardData3 = {
            x: boardData2.x + boardData2.width, // + this.colPad,
            y: boardData2.y,
            width: this.changeData((2000 + lastNum - 200) / 2),
            height: boardData2.height,
            color: boardData2.color,
            i: boardData2.i + 1
          };
          // 右侧2 100板子
          const boardData4 = {
            x: boardData3.x + boardData3.width + this.colwidth,
            y: boardData3.y,
            width: this.changeData(100),
            height: boardData3.height,
            color: boardData3.color,
            i: boardData3.i
          };
          // 添加板子数据
          this.boardData.push(boardData);
          this.boardData.push(boardData2);
          this.boardData.push(boardData3);
          this.boardData.push(boardData4);

          // 左侧柱子1
          const colData = {
            x: prevColData.x + prevColData.width + this.changeData((2000 + lastNum - 200) / 2 + 100), // + this.colPad,
            y: prevColData.y,
            width: prevColData.width,
            height: prevColData.height,
            color: prevColData.color
          };
          // 右侧柱子2
          const colData2 = {
            x: colData.x + colData.width + this.changeData((2000 + lastNum - 200) / 2 + 100), // + this.colPad,
            y: colData.y,
            width: colData.width,
            height: colData.height,
            color: colData.color
          };
          this.colData.push(colData);
          this.colData.push(colData2);

          // 左侧直继手
          const xkmData = {
            x: prevXkmData.x + prevXkmData.width + this.colwidth + this.changeData((2000 + lastNum - 200) / 2 + 100) + (this.colPad - this.zjsWidth),
            y: prevXkmData.y,
            width: prevXkmData.width,
            height: prevXkmData.height,
            color: prevXkmData.color
          };
          // 右侧小口帽
          const xkmData2 = {
            x: xkmData.x + xkmData.width + this.colwidth + this.changeData((2000 + lastNum - 200) / 2 + 100) + (this.colPad - this.zjsWidth + 2),
            y: xkmData.y,
            width: xkmData.width,
            height: xkmData.height,
            color: xkmData.color
          };
          this.xkmData.push(xkmData);
          this.xkmData.push(xkmData2);
        }
      }
    },

    // 增加每行板子数据
    addBoardNum() {
      const padding = 5; //板子间距
      const addData = []; // 新增板子数据
      const bs = 100; // 标识

      for (let i = 0; i < this.boardData.length; i++) {
        // 遍历第一行板子数据
        for (let j = 0; j < this.boardNum; j++) {
          // 增加每一列板子数据
          if (j !== 0) {
            const boardData = {
              x: this.boardData[i].x,
              y: this.boardData[i].y + this.boardheight * j + padding * j, // 每一行增加一个板子高度与padding
              width: this.boardData[i].width,
              height: this.boardData[i].height,
              color: this.colorData[j].color,
              i: this.boardData[i].i + bs * j + 1
            };
            addData.push(boardData);
          }
        }
      }
      // 排序一下 y轴排序 x轴排序 i排序 这样 同一个i数据在一块儿 同一个y轴 不同x轴
      this.boardData = [...this.boardData, ...addData]
        .sort((a, b) => a.y - b.y)
        .sort((a, b) => a.x - b.x)
        .sort((a, b) => a.i - b.i); // 合并新板子数据
    },

    // 增加每行小口帽数据
    addZjsNum() {
      const padding = 5; //板子间距
      const addData = []; // 新增直継手/小口帽数据

      for (let i = 0; i < this.xkmData.length; i++) {
        // 遍历第一行直継手/小口帽数据
        for (let j = 0; j < this.boardNum; j++) {
          // 增加每一列直継手/小口帽数据
          if (j !== 0) {
            const zjsData = {
              x: this.xkmData[i].x,
              y: this.xkmData[i].y + this.boardheight * j + padding * j, // 每一行增加一个板子高度与padding
              width: this.xkmData[i].width,
              height: this.xkmData[i].height,
              color: this.xkmData[i].color
            };
            addData.push(zjsData);
          }
        }
      }
      this.xkmData = [...this.xkmData, ...addData]; // 合并新直継手/小口帽数据
    },

    // 构造固定柱子上钉子数据
    createMiddeleArcData() {
      const padding = 5;
      for (let i = 0; i < this.middleColunmData.length; i++) {
        const data = {
          x: this.middleColunmData[i].x + this.colwidth / 2,
          y: this.boardData[0].y,
          color: this.colorData[0].color // 第一行颜色
        };
        this.middleNailDta.push(data);
      }

      const addData = []; // 新增每行钉子数据
      for (let i = 0; i < this.middleNailDta.length; i++) {
        for (let j = 0; j < this.boardNum; j++) {
          if (j !== 0) {
            const data = {
              x: this.middleNailDta[i].x,
              y: this.middleNailDta[i].y + this.boardheight * j + padding * j, // 每一行增加一个板子高度与padding
              color: this.colorData[j].color
            };
            addData.push(data);
          }
        }
      }
      this.middleNailDta = [...this.middleNailDta, ...addData];
    },

    // 构造插地柱子钉子数据
    createArcData() {
      const padding = 5;
      const addData = [];
      for (let i = 0; i < this.colData.length; i++) {
        const data = {
          x: this.colData[i].x + this.colwidth / 2,
          y: this.boardData[0].y,
          color: this.colorData[0].color // 第一行颜色
        };
        this.nailData.push(data);
      }

      for (let i = 0; i < this.nailData.length; i++) {
        for (let j = 0; j < this.boardNum; j++) {
          if (j !== 0) {
            const data = {
              x: this.nailData[i].x,
              y: this.nailData[i].y + this.boardheight * j + padding * j, // 每一行增加一个板子高度与padding
              color: this.colorData[j].color
            };
            addData.push(data);
          }
        }
      }
      this.nailData = [...this.nailData, ...addData];
    },

    // 根据数据绘图
    drawNewFence(ctx) {
      // 添加阴影效果
      ctx.shadowColor = '#2c2c2c91';
      ctx.shadowOffsetY = 3;
      ctx.shadowBlur = 5;

      // 画柱子与接头颜色
      for (let i = 0; i < this.colData.length; i++) {
        //  画柱子
        ctx.beginPath();
        ctx.fillStyle = this.columnColor;
        ctx.rect(this.colData[i].x, this.colData[i].y, this.colData[i].width, this.colData[i].height);
        ctx.fill();
      }

      // 画板子
      // 这里的板子特殊处理 多个同列板子合并一个
      const boardData = [];
      let curI = -1;
      for (let i = 0; i < this.boardData.length; i++) {
        const item = JSON.parse(JSON.stringify(this.boardData[i])); // 深拷贝 避免数据污染
        if (item.i !== curI) {
          // 更换当前列标识i
          curI = item.i;
          // 合并同列板子数据
          let width = 0;
          const curIBoardData = this.boardData.filter((k) => k.i === curI);
          curIBoardData.forEach((l) => {
            width = width + l.width;
          });
          // 最终板子长度为 同列板子长度和 + n个板子-1的柱子宽度
          item.width = width + this.colwidth * (curIBoardData.length - 1);
          boardData.push(item);
        }
      }
      // 绘制整理后的板子数据
      for (let i = 0; i < boardData.length; i++) {
        ctx.beginPath();
        ctx.fillStyle = boardData[i].color;
        ctx.rect(boardData[i].x, boardData[i].y, boardData[i].width, boardData[i].height);
        ctx.fill();
      }

      // 画插地柱子钉子
      for (let i = 0; i < this.nailData.length; i++) {
        ctx.beginPath();
        ctx.fillStyle = this.nailData[i].color;
        ctx.arc(this.nailData[i].x, this.nailData[i].y + 5, this.nailradius, 0, 2 * Math.PI); // 上面钉子 只改变y轴坐标
        ctx.arc(this.nailData[i].x, this.nailData[i].y + 15, this.nailradius, 0, 2 * Math.PI); // 下面钉子 只改变y轴坐标
        ctx.fill();
      }

      // 画小口帽
      // for (let i = 0; i < this.xkmData.length; i++) {
      //   ctx.beginPath();
      //   ctx.fillStyle = this.xkmData[i].color;
      //   ctx.rect(this.xkmData[i].x, this.xkmData[i].y, this.xkmData[i].width, this.xkmData[i].height);
      //   ctx.fill();
      // }
    },

    // 画标尺
    drawSize(ctx) {
      // 画底线
      this.drawLine(ctx);
      // 标左侧尺寸
      this.drawLeftSize(ctx);
    },

    // 标板子长度尺寸
    drawBoardSize(ctx) {
      // 总长标注
      const allx = this.colData[0].x - 150; // 第一个柱子x坐标
      ctx.fillStyle = '#909399'; // 文本颜色
      ctx.font = '20px Verdana';
      ctx.fillText('W' + this.reallength, allx, 100); // (文本内容，x，y)

      let curX = 0;
      ctx.fillStyle = '#749FBF';
      ctx.font = '18px Verdana';
      ctx.textAlign = 'center';
      for (let i = 0; i < this.boardData.length; i++) {
        // 仅遍历第一行板子
        if (this.boardData[i].x > curX) {
          curX = this.boardData[i].x;
          ctx.fillText(this.changeRealData(this.boardData[i].width), curX + this.boardData[i].width / 2, 120); // width转换成真实尺寸
        }
      }
    },

    // 标注侧相关数据
    drawLeftSize(ctx) {
      // 总高度 H
      const Hx = 60;
      const Hy = this.colheight;
      ctx.fillStyle = '#909399';
      ctx.font = '20px Verdana';
      ctx.fillText('H' + (this.colheight / 20) * 100, Hx, Hy);

      // 板子高度 T
      const Tx = 240;
      const Ty = this.boardData[this.boardData.length - 1].y; // - 50;
      const allBoardHeight = this.boardNum * 120 + (this.boardNum - 1) * 10;
      ctx.fillStyle = '#909399';
      ctx.font = '20px Verdana';
      ctx.fillText(allBoardHeight, Tx, Ty);

      // 离地高度 T
      const Gx = 240;
      const Gy = this.colData[0].y + this.colData[0].height - 20; // 线段y坐标
      ctx.fillStyle = '#909399';
      ctx.font = '20px Verdana';
      ctx.fillText((this.colheight / 20) * 100 - allBoardHeight, Gx, Gy);
    },

    // 标地线
    drawLine(ctx) {
      const lastBoardLength = this.boardData.length;
      const colbottomY = this.colData[0].y + this.colData[0].height; // 线段y坐标
      const collastX = this.boardData[lastBoardLength - 1].x + this.boardData[lastBoardLength - 1].width; // 线段结尾x坐标 // 板子最后x坐标 + 板子宽度

      ctx.strokeStyle = '#909399';
      ctx.beginPath();
      ctx.moveTo(100, colbottomY); // 线段起始坐标
      ctx.lineTo(collastX, colbottomY); // 线段结束坐标
      ctx.closePath();
      ctx.stroke();

      // 写文本
      ctx.fillStyle = '#909399';
      ctx.font = '20px Verdana';
      ctx.fillText('GL', 60, colbottomY);
    },

    // canvas截图
    getCanvas() {
      let dom = document.getElementById(this.canvasId);
      let ctx = dom.getContext('2d');
      let width = dom.getAttribute('width'); // 获取当前画布宽度
      // let height = dom.getAttribute("height"); // 获取当前画布高度

      ctx.clearRect(0, 0, width, 75); // 清除文字指定区域内容
      // this.newInit(); // 先绘图

      let form = new FormData(); // 创建表单后续放图片

      // 获取当前时间戳
      const dataTime = Date.parse(new Date());
      return new Promise((resolve) => {
        // 柱子小于四列，只显示一个图
        if (this.colData.length <= 4) {
          ctx.fillStyle = '#909399';
          ctx.font = '30px Verdana';
          ctx.fillText('立面図', 60, 60);

          dom.toBlob((blob) => {
            form.append('image', blob, `left_${this.canvasId}${dataTime}.png`);
            resolve(form);
          });
        } else {
          let width = dom.getAttribute('width'); // 获取画布宽度

          // 左侧文字
          ctx.fillStyle = '#909399';
          ctx.font = '30px Verdana';
          ctx.fillText('立面図（左端）', 120, 60); // x为0, 左对齐

          // 右侧文字
          ctx.fillStyle = '#909399';
          ctx.font = '30px Verdana';
          ctx.fillText('立面図（右端）', width - ctx.measureText('立面図（右端）').width, 60); // 总宽度 - 获取字符串宽度 = 右侧x坐标

          // 截取开头部分
          let beginCanvas = document.createElement('canvas');
          let beginCtx = beginCanvas.getContext('2d');

          beginCanvas.width = 820;
          beginCanvas.height = dom.getAttribute('height');

          beginCtx.drawImage(dom, 0, 0, beginCanvas.width, beginCanvas.height, 0, 0, beginCanvas.width, beginCanvas.height);

          // document.body.appendChild(beginCanvas)

          beginCanvas.toBlob((blob) => {
            form.append('image', blob, `left_${this.canvasId}${dataTime}.png`);
          });

          // 截取结尾部分
          let endCanvas = document.createElement('canvas');

          let endCtx = endCanvas.getContext('2d');

          // 获取倒数第二排板子的x坐标
          // const boardX = this.boardData[this.boardData.length - this.boardNum - 1].x - this.colwidth * 2

          // 倒数第二根柱子坐标-10 开始截图坐标
          const boardX = this.colData[this.colData.length - 2].x - 10;

          // 总长度为 boardX坐标到 最后文字结束
          const endWidth = this.boardData[this.boardData.length - 1].x + this.boardData[this.boardData.length - 1].width - boardX + 100;

          endCanvas.width = endWidth;
          endCanvas.height = dom.getAttribute('height');

          endCtx.drawImage(dom, boardX, 0, endCanvas.width, endCanvas.height, 0, 0, endCanvas.width, endCanvas.height);

          // document.body.appendChild(endCanvas)

          return endCanvas.toBlob((blob) => {
            form.append('image', blob, `right_${this.canvasId}${dataTime}.png`);
            resolve(form);
          });
        }
      });
    },

    getColNum() {
      return this.middleColunmData.length + this.colData.length;
    }
  }
};
</script>

<style></style>
